"use client";
import { CrystallizeProvider } from "@crystallize/reactjs-hooks";
import { AppContextProvider } from "~/ui/app-context/provider";
import { KlaviyoProvider } from "~/ui/components/aplia/Klaviyo/KlaviyoProvider";
import { KlaviyoPageTracker } from "~/ui/components/aplia/Klaviyo/KlaviyoPageTracker";

export function Providers({
  language,
  tenantIdentifier,
  translations,
  initialState,
  children,
}: any) {
  return (
    <CrystallizeProvider
      language={language}
      tenantIdentifier={tenantIdentifier}
    >
      <AppContextProvider
        initialState={initialState}
        translations={translations}
      >
          <KlaviyoProvider>
            <KlaviyoPageTracker />
            {children}
          </KlaviyoProvider>
      </AppContextProvider>
    </CrystallizeProvider>
  );
}
